import { useMutation } from "@apollo/client";

import { GqlCourseUpdateInput } from "~/__generated__";

import { CourseEditRoute_UpdateDocument } from "../mutations.generated";

export default function useCourseEditRoute_Update() {
    const [updateCourse, { loading, error }] = useMutation(CourseEditRoute_UpdateDocument);

    const update = (courseId: string, input: Omit<GqlCourseUpdateInput, "courseId">) =>
        updateCourse({
            variables: { input: { ...input, courseId } },
        });

    return {
        updateCourse: update,
        loading,
        error,
    };
}
